module.exports = __webpack_public_path__ + "static/media/habi.4d73fc89.svg";